module.exports = __webpack_public_path__ + "img/google_drive_neg.80717285.svg";